import "swiper/css";
import "../scss/product.scss";
import { recommendationAPI } from '../components/upsell-api'
import { stickyCart } from "../components/sticky-cart";
import { priceAutOfStock } from "../components/price-out-of-stock";
import { initSeeAll } from '../utils/accordion';
import { createInterception } from "../utils/script-defer";
import { addTagScript } from "../utils/add-tag-script";
import { $Q } from "../utils/query-selector";

stickyCart();
initSeeAll();
priceAutOfStock();
recommendationAPI();

const productcore = $Q('product-core');
createInterception(productcore, async () => {
  const { dataset: { script } } = $Q('.product-core-script');
  await addTagScript(script, 'productCore');
});
